import { AnyAction } from 'redux';
import { DesignData } from 'src/store/design/types';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import { setDesignStructureAction, setDesignTotalPagesCountAction } from 'src/store/design/slice';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import countNumberOfPages from 'src/util/design/countNumberOfPages';
import getUsedSpreads from 'src/util/design/getUsedSpreads';
import calculateDisabledPrintAreas from 'src/util/design/calculateDisabledPrintAreas';
import getStructure from '../selector/getStructure';

const setDesignStructureOperation = (structure: DesignData) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const store = getState();
  const oldStructure = getStructure(store);

  // Check if used spreads have changed
  const oldUsedSpreads = getUsedSpreads(oldStructure);
  const newUsedSpreads = getUsedSpreads(structure);

  const usedSpreadsChanged = oldUsedSpreads.size !== newUsedSpreads.size
    || Array.from(newUsedSpreads).some((spreadName) => !oldUsedSpreads.has(spreadName));

  dispatch(setDesignStructureAction(structure));
  dispatch(setDesignTotalPagesCountAction(structure.page_count || countNumberOfPages(structure)));

  // Only send disabled print areas if used spreads have changed
  if (usedSpreadsChanged) {
    const disabledPrintAreas = calculateDisabledPrintAreas(structure);
    sendPostMessage({
      type: MESSAGE_TYPE['editor.setDisabledSpreads'],
      data: disabledPrintAreas,
    });
  }
};

export default setDesignStructureOperation;
